const UNITS = [
  ['DAY', 86400],
  ['HOUR', 3600],
  ['MINUTE', 60],
  ['SECOND', 1],
];

/**
 * Formats a duration in seconds as the two largest non-zero units,
 * e.g. "1 д 2 ч" or "35 мин 54 с", using REPORT.DURATION.* i18n keys.
 *
 * @param {number} timeInSeconds - Duration in seconds.
 * @param {Function} t - i18n translate function.
 * @returns {string} The localized human-readable duration.
 */
export const formatDuration = (timeInSeconds, t) => {
  let rest = Math.round(timeInSeconds || 0);
  const parts = [];
  UNITS.forEach(([key, size]) => {
    const qty = Math.floor(rest / size);
    rest -= qty * size;
    if (qty > 0) parts.push(`${qty} ${t(`REPORT.DURATION.${key}`)}`);
  });
  if (!parts.length) return `0 ${t('REPORT.DURATION.SECOND')}`;
  return parts.slice(0, 2).join(' ');
};
